export default "__VITE_ASSET__DAhmfiOn__"